<div id="wrapper">
  <div>
    <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
  </div>
  <div>
    <app-tab-nav [visible]="true" (updatePostpaid)="this.postpago=$event" (updatePrepaid)="this.prepago=$event"
      (updateFixed)="this.telefoniaFijo=$event" (updateTotalAccountList)="this.totalAccountList=$event"
      (updateCurrentList)="this.currentList=$event" (updateSelectBan)="this.selectBan=$event"
      (updateInitializeData)="this.initializeData()"></app-tab-nav>
  </div>
  <app-add-product *ngIf="this.totalAccountList==0"></app-add-product>
  <div class="allcont logsize" *ngIf="this.totalAccountList > 0">
    <div class="container">
      <div class="basicrow">
        <div class="fulltitle m-top-i f-btitle autodef">
          <span class="icon-dash-26"></span> Compras
        </div>
      </div>
      <div class="basicrow m-top-i">
        <img width="100%" src="../../../assets/images/buysbanner.jpg">
      </div>
      <div class="basicrow m-top-i">
        <div class="basicrow f-title roboto-l f-black">
          Nuestros Servicios
        </div>
        <div class="basicrow">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 m-top-iii">
              <div class="row">
                <div class="col-xs-3 col-sm-3 col-md-4 col-lg-4">
                  <img width="100%" src="../../../assets/images/buyimage-i.jpg">
                </div>
                <div class="col-xs-9 col-sm-9 col-md-8 col-lg-8">
                  <div class="buytitle f-big roboto-l f-black">
                    Tienda
                  </div>
                  <div class="basicrow f-mildt roboto-l f-mgray">
                    Descubre los equipos que puedes comprar por internet.
                  </div>
                  <div class="basicrow m-top-ii">
                    <a  (click)="global.goStore()" rel="noopener noreferrer" class="linkdefs f-med">
                      Ver Detalles&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 m-top-iii" *ngIf="this.postpago==true">
              <div class="row">
                <div class="col-xs-3 col-sm-3 col-md-4 col-lg-4">
                  <img width="100%" src="../../../assets/images/buyimage-ii.jpg">
                </div>
                <div class="col-xs-9 col-sm-9 col-md-8 col-lg-8">
                  <div class="buytitle f-big roboto-l f-black">
                    Compra de Paquetes Adicionales de Datos
                  </div>
                  <div class="basicrow f-mildt roboto-l f-mgray">
                    No te quedes sin navegar, compra data adicional aqui.
                  </div>
                  <div class="basicrow m-top-ii">
                    <a routerLink="/datapurchase" ui-sref="datapurchase" class="linkdefs f-med">
                      Ver Detalles&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 m-top-iii" *ngIf="this.postpago==true">
              <div class="row">
                <div class="col-xs-3 col-sm-3 col-md-4 col-lg-4">
                  <img width="100%" src="../../../assets/images/buyimage-iv.jpg">
                </div>
                <div class="col-xs-9 col-sm-9 col-md-8 col-lg-8">
                  <div class="buytitle f-big roboto-l f-black">
                    Regala 1GB
                  </div>
                  <div class="basicrow f-mildt roboto-l f-mgray">
                    Regala 1GB a un amigo/a o familiar que sea cliente Movil Postpago.
                  </div>
                  <div class="basicrow m-top-ii">
                    <a routerLink="/giveone" ui-sref="giveone" class="linkdefs f-med">
                      Ver Detalles&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 m-top-iii" *ngIf="this.postpago==true">
                <div class="row">
                    <div class="col-xs-3 col-sm-3 col-md-4 col-lg-4">
                      <img width="100%" src="../../../assets/images/buyimage-v.jpg">
                    </div>
                    <div class="col-xs-9 col-sm-9 col-md-8 col-lg-8">
                      <div class="buytitle f-big roboto-l f-black">
                        Regala 1 Recarga
                      </div>
                      <div class="basicrow f-mildt roboto-l f-mgray">
                        Regala 1 Recarga a un amigo/a o familiar que sea cliente prepago.
                      </div>
                      <div class="basicrow m-top-ii">
                        <a routerLink="/giverecharge" ui-sref="giverecharge" class="linkdefs f-med">
                          Ver Detalles&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                        </a>
                      </div>
                    </div>
                  </div>
            </div>
							<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 m-top-iii">
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
